import api from '../../utils/api';

export interface AmbulanceOffHoursTotals {
  total: number;
  android: number;
  ios: number;
  web: number;
}

export interface AmbulanceOffHoursRow {
  userId: string;
  totalClicks: number;
  androidClicks: number;
  iosClicks: number;
  webClicks: number;
  lastClickAt: string | null;
  displayName: string | null;
  phoneNumber: string | null;
  email: string | null;
  userKind: string;
}

export interface AmbulanceOffHoursAnalyticsData {
  eventType: string;
  days: number;
  totals: AmbulanceOffHoursTotals;
  rows: AmbulanceOffHoursRow[];
}

export interface AmbulanceOffHoursAnalyticsResponse {
  success: boolean;
  message?: string;
  data?: AmbulanceOffHoursAnalyticsData;
}

export async function getAmbulanceOffHoursClicks(days = 90): Promise<AmbulanceOffHoursAnalyticsResponse> {
  const response = await api.get<AmbulanceOffHoursAnalyticsResponse>(
    '/master-admin/analytics/ambulance-off-hours-clicks',
    { params: { days } }
  );
  return response.data;
}
